import { useParams } from 'react-router-dom';
// components
import EditTemplate from 'src/components/templates/customer/customer-edit-template';
import Page from 'src/components/molecules/page';
import usePush from 'src/hooks/use-push';
// hooks
import useFetch from 'src/hooks/use-fetch';
// function
import { customerValueOrganize as valueOrganize } from 'src/functions/push-value-organize';
import { CustomerForm } from 'src/types/customer-form';
import { Customer } from 'codegen/axios/photo/admin/api';

export default function Edit() {
  /* hook宣言 */
  const push = usePush();
  const { customerId } = useParams();

  /* 定数宣言 */
  const title = '顧客編集';
  const initValue: CustomerForm = {
    customerFirstName: '',
    customerLastName: '',
    customerFirstNameKana: '',
    customerLastNameKana: '',
    email: '',
    telno: '',
  };

  /* データ取得 */
  const { fetchedData: responseData } = useFetch<CustomerForm & Customer>({
    iniState: initValue,
    reqProp: {
      pathKey: 'customer',
      pathParam: customerId,
    },
  });
  const OnSubmit = (formValue: any) =>
    new Promise((resolve) => {
      push(resolve, {
        reqProp: { pathKey: 'customer', method: 'put', pathParam: customerId, data: valueOrganize(formValue) },
        aftProp: {
          resolve,
          nextPath: `/customers/${customerId}`,
          showMessage: {
            state: { snackBar: { open: true, viewType: 'success', message: '登録しました。' } },
          },
        },
      });
    });

  return (
    <Page title={title}>
      <EditTemplate
        {...(() => ({
          OnSubmit,
          title,
          responseData,
        }))()}
      />
    </Page>
  );
}
